module.exports = __webpack_public_path__ + "static/media/Portrait-10016.2f1ebd25.jpg";